import API from '@/shared/plugins/Api/API'

class DeployScheduleV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  // Returns the start/stop schedule config (enabled, timezone, windows) plus
  // read-only status (override, next transition, last action/error).
  async get (appName) {
    return this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/deploy-schedule`
    })
  }

  // Full replacement: always send the complete { enabled, timezone, windows }.
  // Status fields are ignored server-side.
  async update (appName, schedule) {
    return this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/deploy-schedule`,
      data: schedule
    })
  }
}

export default DeployScheduleV3
